export default "__VITE_ASSET__B5ljnsl8__"